
import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, IconButton, Switch, Typography } from "@mui/material";
import { Link, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { shiftHistoryList } from "../../../SampleData/ShiftHistoryList";
import ShiftHistoryModal from "./ShiftHistoryModal";
import HandOver from "./HandOver";
import TakeOver from "./TakeOver";



import ResponsiveDialog from "../../../Component/ResponsiveDialog";
const ShiftHistoryList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const actionsAllow = useSelector((state) => state.dataRed.actionsAllow);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(shiftHistoryList);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue, setFilterValue] = useState("enableData");
  const [backUpData, setBackUpData] = useState([]);
  const [handOver,setHandOver]=useState(false)
  const [takeOver,setTakeOver]=useState(false)

  //   useEffect(() => {
  //     getData();
  //   }, []);

  //   const getData = async() => {
  //     setIsLoading(true);
  //     const link = masterAPI["assetCategory"].link;
  //    await axiosPrivate
  //       .get(`${link}`)
  //       .then((res) => {
  //         res.data.result.sort((a, b) => {
  //           return a.code.localeCompare(b.code, undefined, {
  //             numeric: true,
  //             sensitivity: 'base'
  //           });
  //         });
  //         if(filterValue==="enableData"){
  //           const filterDataResult=res.data.result.filter(fil=>fil.isActive)
  //           console.log(filterDataResult, "locationresult");
  //           setData(filterDataResult);
  //           setBackUpData(res.data.result)
  //         }else{
  //           setData(res.data.result)
  //           setBackUpData(res.data.result)
  //         }
  //         setIsLoading(false);
  //       })
  //       .catch((e) => {
  //         console.log(e, "assetCategory");
  //         setIsLoading(false);
  //         setData([])
  //         setBackUpData([])
  //       });
  //   };

  const handleButtonNew = () => {
    // setMode("Create");
    // setCreate(true);
  };
  const handleCreate=()=>{
    setCreate(true)
  }
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    // getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  const columns = [
    {
      Header: "Shift Code",
      accessor: "id",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              color: "#0d6efd",
              textDecorationLine: "underline",
              fontWeight: 800,
              cursor: "pointer",
              fontSize:"inherit"
            }}
            onClick={() => {
                          handleEdit(cell.row.original);
                         }}
          >
            {cell.value}
          </Typography>
        );
      },
      // disableFilters: true,
    },
    {
      Header: "Responsible",
      accessor: "Responsible",
      // disableFilters: true,
    },
    {
      Header: "Shift active",
      accessor: "Shift_active",
    },
    {
      Header: "Start date",
      accessor: "Start_date",
    },
    {
      Header: "Start time",
      accessor: "Start time",
    },
    {
        Header: "End date",
        accessor: "End_date",
      },
      {
        Header: "End time",
        accessor: "End_time",
      },
      {
        Header: "Shift resp. area key",
        accessor: "Shift_resp_area_key",
      },
      {
        Header: "Shift type key",
        accessor: "Shift_type_key",
      },
    // {
    //   Header: "Actions",
    //   Cell: ({ cell }) => {
    //     // console.log(cell)
    //     return (
    //       <Box sx={{ whiteSpace: "nowrap" }}>
    //         <IconButton disabled={!actionsAllow.edit}>
    //           <EditOutlined
    //             onClick={() => {
    //               handleEdit(cell.row.original);
    //             }}
    //             sx={{
    //               fontSize: color.masterEditDelButton,
    //               color:actionsAllow.edit? color.masterEditDelButtonColor:"default",
    //             }}
    //           />
    //         </IconButton>
    //         {/* <IconButton
    //         disabled={!actionsAllow.delete}
    //         >
    //           <DeleteOutline
    //             onClick={() => {
    //               handleDelete(cell.row.original.id);
    //             }}
    //             sx={{
    //               fontSize: color.masterEditDelButton,
    //               color:actionsAllow.delete? color.masterEditDelButtonColor:"default",
    //             }}
    //           />
    //         </IconButton> */}
    //         <Switch
    //         disabled={!actionsAllow.delete}
    //         checked={cell.row.original.isActive}
    //         onChange={(e)=>{handleDelete(e,cell.row.original.id)}}

    //          />
    //       </Box>
    //     );
    //   },
    // },
  ];

  const handleChangeFilter = (e) => {
    if (e === "showAll") {
      setData(backUpData);
    } else {
      const filterDataResult = backUpData.filter((fil) => fil.isActive);

      setData(filterDataResult);
    }
    setFilterValue(e);
  };

  const handleHandOver=()=>{
    setHandOver(true)
  }
  const handleTakeOver=()=>{
    setTakeOver(true)
  }
  

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          Shift History
        </Typography>
      </Box>

      <TableContainer
        columns={columns}
        data={data}
          buttonNew={handleButtonNew}
        loading={isLoading}
        buttonDisable={!actionsAllow.create}
        //   filterValue={filterValue}
        //   handleChange={handleChangeFilter}
        handAndtake={true}
        handleHandOver={handleHandOver}
        handleTakeOver={handleTakeOver}
        filterShow={false}
        display={"notVisible"}
      />

      <ResponsiveDialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"lr"}
        children={
          <ShiftHistoryModal
  
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
      <ResponsiveDialog
        open={handOver}
        onClose={()=>{setHandOver(false)}}
        maxWidth={"md"}
        children={
          <HandOver
  
            handleCloseClick={()=>{setHandOver(false)}}
            mode={mode}
            editData={editData}
          />
        }
      />
       <ResponsiveDialog
        open={takeOver}
        onClose={()=>{setTakeOver(false)}}
        maxWidth={"md"}
        children={
          <TakeOver
  
            handleCloseClick={()=>{setTakeOver(false)}}
            mode={mode}
            editData={editData}
          />
        }
      />
    </>
  );
};

export default ShiftHistoryList;
